export default [
  {
    path: '/lot/create-lot-manifest',
    name: 'create-lot-manifest',
    component: () => import(/* webpackChunkName: "lot-routes" */ '@/views/Lots/components/CreateLotManifest.vue'),
    meta: { permission: 'api.add_lotmanifest' }
  },
  {
    path: '/lot/:id',
    component: () => import(/* webpackChunkName: "lot-routes" */ '@/views/Lots/LotParent'),
    reverse: 'lots-single',
    meta: { permission: 'api.view_lot' },
    children: [
      {
        path: '',
        name: 'lot',
        component: () => import(/* webpackChunkName: "lot-routes" */ '@/views/Lots/Lot'),
        reverse: 'lots-single',
        meta: { permission: 'api.view_lot' }
      }
    ]
  },
  {
    path: '/lot/:id/reallocate-purchases',
    name: 'reallocate-purchases',
    component: () => import(/* webpackChunkName: "lot-routes" */ '@/views/Lots/LotReallocatePurchases'),
    meta: { permission: 'api.change_lot' }
  },
  {
    path: '/lot/:id/inventory',
    name: 'lot-inventory',
    meta: {
      permission: 'api.change_lot',
      redirect: '/site/lots/{id}/inventory/'
    }
  },
  {
    path: '/lot/:id/create-manifest',
    name: 'lot-create-manifest',
    meta: {
      permission: 'logistics.add_transitmanifest',
      redirect: '/site/lots/{id}/create-manifest/'
    }
  },
  {
    path: '/lot/:id/shipment-result',
    name: 'shipment-result',
    component: () => import(/* webpackChunkName: "lot-routes" */ '@/views/Lots/ShipmentResult/ShipmentResult.vue'),
    meta: { permission: 'api.view_shipmentresult' }
  },
  {
    path: '/lot/:id/shipment-result/print',
    name: 'shipment-result-print',
    component: () => import(/* webpackChunkName: "lot-routes" */ '@/views/Lots/ShipmentResult/ShipmentResultPrint.vue'),
    meta: { permission: 'api.view_shipmentresult' }
  },
  {
    path: '/lot/:id/advance-calculator',
    name: 'advance-calculator',
    component: () => import(/* webpackChunkName: "lot-routes" */ '@/views/Lots/AdvanceCalculator/AdvanceCalculator.vue'),
    meta: { permission: 'api.view_advancecalculator' }
  },
  {
    path: '/lot/:id/advance-calculator/print',
    name: 'advance-calculator-print',
    component: () => import(/* webpackChunkName: "lot-routes" */ '@/views/Lots/AdvanceCalculator/AdvanceCalculatorPrint.vue'),
    meta: { permission: 'api.view_advancecalculator' }
  },
  {
    path: '/lot/:id/client-proforma',
    name: 'client-proforma',
    component: () => import(/* webpackChunkName: "lot-routes" */ '@/views/Lots/ClientProforma/ClientProforma.vue'),
    meta: { permission: 'api.view_clientproforma' }
  },
  {
    path: '/lot/:id/client-proforma/print',
    name: 'client-proforma-print',
    component: () => import(/* webpackChunkName: "lot-routes" */ '@/views/Lots/ClientProforma/ClientProformaPrint.vue'),
    meta: { permission: 'api.view_clientproforma' }
  },
  {
    path: '/lot/:id/internal-proforma',
    name: 'internal-proforma',
    component: () => import(/* webpackChunkName: "lot-routes" */ '@/views/Lots/InternalProforma/InternalProforma.vue'),
    meta: { permission: 'api.view_internalproforma' }
  },
  {
    path: '/lot/:id/internal-proforma/print',
    name: 'internal-proforma-print',
    component: () => import(/* webpackChunkName: "lot-routes" */ '@/views/Lots/InternalProforma/InternalProformaPrint.vue'),
    meta: { permission: 'api.view_internalproforma' }
  },
  {
    path: '/lot/:id/internal-report/print',
    name: 'internal-report-print',
    // component: () => import(/* webpackChunkName: "lot-routes" */ '@/views/Lots/InternalReport/InternalReportPrint.vue')
    component: () => {},
    meta: {
      permission: 'api.view_lot_report',
      redirect: '/site/lots/{id}/internal_reports/print/'
    }
  },
  {
    path: '/lot/:id/allocations/',
    name: 'lot-allocations',
    // component: () => import(/* webpackChunkName: "lot-routes" */ '@/views/Lots/InternalReport/InternalReportPrint.vue')
    component: () => {},
    meta: {
      permission: 'api.view_lot_allocation',
      redirect: '/site/lots/{id}/allocations/'
    }
  },
  {
    path: '/brokered-settlement/:id',
    name: 'brokered-settlement',
    component: () => import(/* webpackChunkName: "lot-routes" */ '@/views/Lots/components/Brokered/EditBrokeredSettlement'),
    reverse: 'brokered-settlement',
    meta: { permission: 'api.change_brokeredsettlement' }
  },
  {
    path: '/brokered-settlement/:id/print',
    name: 'print-brokered-settlement',
    component: () => import(/* webpackChunkName: "lot-routes" */ '@/views/Lots/components/Brokered/BrokeredSettlementPrint'),
    meta: { permission: 'api.view_brokeredsettlement' }
  },
  {
    path: '/transit/lot-manifest/:id',
    name: 'lot-manifest',
    component: () => import(/* webpackChunkName: "lot-routes" */ '@/views/Lots/components/LotManifest.vue'),
    meta: { permission: 'api.view_lotmanifest' }
  },
  {
    path: '/lot/:id/finance',
    name: 'lot-finance',
    component: () => import(/* webpackChunkName: "lot-routes" */ '@/views/FinanceReport/LotFinance'),
    meta: { permission: 'api.view_lot' }
  },
  {
    path: '/shipment-summary/final-report/:id',
    name: 'lot-final-report',
    component: () => import(/* webpackChunkName: "lot-routes" */ '@/views/FinanceReport/FinalReport'),
    meta: { permission: 'api.view_finalreport' }
  },
  {
    path: '/lot-list',
    component: () => import(/* webpackChunkName: "lot-routes" */ '@/views/Lots/LotListParent'),
    children: [
      {
        path: '',
        name: 'lot-list',
        component: () => import(/* webpackChunkName: "lot-routes" */ '@/views/Lots/LotList'),
        meta: { permission: 'api.view_lot' }
      },
      {
        path: 'shipped',
        name: 'lot-shipped-list',
        component: () => import(/* webpackChunkName: "lot-routes" */ '@/views/Lots/LotShippedList'),
        meta: { permission: 'api.view_lot' }
      },
      {
        path: '/create-lot',
        name: 'create-lot',
        component: () => import(/* webpackChunkName: "lot-routes" */ '@/views/Lots/CreateLot'),
        meta: { permission: 'api.add_lot' }
      },
      {
        path: '/position-report',
        name: 'lots-position-report',
        component: () => {
        },
        meta: {
          permission: 'api.view_lot_report',
          redirect: '/site/lots/position_report/'
        }
      }
    ]
  },
  {
    path: '/lot/:id/shipping-labels',
    name: 'shipping-labels',
    component: () => import(/* webpackChunkName: "lot-routes" */ '@/views/Lots/components/ShippingLabels'),
    meta: { permission: 'api.view_lot' }
  },
  {
    path: '/shipment-summary/:id',
    name: 'shipment-summary',
    component: () => import(/* webpackChunkName: "lot-routes" */ '@/views/ShipmentSummaries/components/Read/ShipmentSummary'),
    reverse: 'shipment_summaries-single',
    meta: {
      permission: 'api.view_shipmentsummary',
      redirect: '/site/lots/shipment_summary/{id}/'
    }
  },
  {
    path: '/shipment-summary-list',
    component: () => import(/* webpackChunkName: "lot-routes" */ '@/views/ShipmentSummaries/ShipmentSummaryParent'),
    children: [
      {
        path: '',
        name: 'shipment-summary-list',
        component: () => import(/* webpackChunkName: "lot-routes" */ '@/views/ShipmentSummaries/ShipmentSummaryList'),
        meta: {
          permission: 'api.view_shipmentsummary',
          redirect: '/site/lots/shipment_summary/'
        }
      },
      {
        path: '/create-shipment-summary',
        name: 'create-shipment-summary',
        component: () => import(/* webpackChunkName: "lot-routes" */ '@/views/ShipmentSummaries/components/Write/CreateShipmentSummary'),
        meta: { permission: 'api.add_shipmentsummary' }
      }
    ]
  },
  {
    path: '/final-report-list',
    name: 'final-report-list',
    component: () => import(/* webpackChunkName: "lot-routes" */ '@/views/FinanceReport/FinalReportList'),
    meta: { permission: 'api.view_finalreport' }
  },
  {
    path: '/reports/smelter-shipment-history-report/',
    name: 'smelter-shipment-history-report',
    meta: {
      redirect: '/site/lots/processing_metrics/'
    }
  },
  {
    path: '/reports/assay-comparison-by-lot/',
    name: 'assay-comparison-by-lot',
    component: () => import(/* webpackChunkName: "lot-routes" */ '@/views/Reports/AssayComparisonByLot.vue'),
    meta: { permission: 'api.view_assayresult' }
  }
]
